import { Row } from '@tanstack/react-table';
import { useTable } from '../TableContext';
import { cn } from '../../../../utils/cn';
import { ReactNode } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { useTranslation } from 'react-i18next';

export const DefaultSubComponentToggle = <T,>({
  isExpanded,
  onToggle,
  children,
  className,
  row,
}: {
  isExpanded: boolean;
  onToggle: () => void;
  children?: ReactNode;
  className?: string;
  row: Row<T>;
}) => {
  const { t } = useTranslation('designSystem');
  const { expansion } = useTable<T>();

  return (
    <button
      data-testid="table-sub-component-toggle"
      onClick={onToggle}
      className={cn(
        'w-full px-4 py-4',
        'transition-colors duration-150',
        isExpanded
          ? 'bg-gray-50 dark:bg-gray-800'
          : 'bg-lightest-gray hover:bg-gray-50 dark:hover:bg-gray-800',
        className,
      )}
    >
      {children || (
        <div className="flex items-center justify-center gap-2">
          {!expansion?.toggleLabel && (
            <span>{isExpanded ? t('hideDetails') : t('showDetails')}</span>
          )}
          {expansion?.toggleLabel && (
            <span>{expansion.toggleLabel({ row, isExpanded })}</span>
          )}
          <span
            className={cn(
              'transition-transform duration-200',
              isExpanded && 'rotate-180',
            )}
          >
            <ChevronDownIcon className="text-action-primary h-4 w-4" />
          </span>
        </div>
      )}
    </button>
  );
};
